import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Carta de ventas progresiva: DESEO → OPORTUNIDAD → PRODUCTO → VARIEDAD →
 * DESEO (rellenos) → LOS DOS TOMOS → CONTENIDO → APLICACIÓN COMERCIAL →
 * PRECIO → OBJECIONES → COMPRA.
 *
 * Ritmo de fondos: marfil → red velvet → blanco → marfil → marfil →
 * pistacho pálido → blanco → marfil → red velvet → blanco → marfil.
 *
 * Todo lo que está debajo del primer pantallazo se carga en chunks aparte para
 * que el Hero (LCP en mobile) llegue con el menor JS posible. Cada bloque
 * reserva altura mientras carga, así el CLS queda en cero.
 */
const DesireSection = lazy(() => import('./components/DesireSection').then(m => ({
  default: m.DesireSection
})));
const CatalogSection = lazy(() => import('./components/CatalogSection').then(m => ({
  default: m.CatalogSection
})));
const FlavorsSection = lazy(() => import('./components/FlavorsSection').then(m => ({
  default: m.FlavorsSection
})));
const StuffedSection = lazy(() => import('./components/StuffedSection').then(m => ({
  default: m.StuffedSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const ContentSection = lazy(() => import('./components/ContentSection').then(m => ({
  default: m.ContentSection
})));
const SellSection = lazy(() => import('./components/SellSection').then(m => ({
  default: m.SellSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="d57dixer88gf" />} data-id="element-0" data-mp="d4o0nv3yoa99">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="83i0xdbvvmq8">
      {/* DESEO */}
      <Hero data-id="element-3" data-mp="3glwcnyc0cfw2" />

      {/* OPORTUNIDAD */}
      <Deferred minHeight="500px" background="bg-ivory" data-id="element-4" data-mp="3bmbevr8kqdkx">
        <DesireSection data-id="element-5" data-mp="3bnutzeihuil4" />
      </Deferred>

      {/* PRODUCTO: 2 tomos, 100 recetas */}
      <Deferred minHeight="860px" background="bg-cream" data-id="element-6" data-mp="3qbzfsrcufa84">
        <CatalogSection data-id="element-7" data-mp="3lkhbpufiwtix" />
      </Deferred>

      {/* VARIEDAD */}
      <Deferred minHeight="1600px" data-id="element-8" data-mp="3lj6bu5p785x3">
        <FlavorsSection data-id="element-9" data-mp="2xun4bsdz3x62" />
      </Deferred>

      {/* DESEO: el relleno */}
      <Deferred minHeight="900px" background="bg-ivory" data-id="element-10" data-mp="2xsk2mb3gkfli">
        <StuffedSection data-id="element-11" data-mp="2suqv9eqf5fjn" />
      </Deferred>

      {/* LOS DOS TOMOS + BONOS: percepción de cantidad y valor */}
      <Deferred minHeight="1040px" background="bg-pistacho-pale" data-id="element-12" data-mp="18c6og57cpuff">
        <TomosSection data-id="element-13" data-mp="1d4zpahzp8im8" />
      </Deferred>

      {/* CONTENIDO */}
      <Deferred minHeight="1100px" background="bg-cream" data-id="element-14" data-mp="1d6ay4w804gk7">
        <ContentSection data-id="element-15" data-mp="ygwjp9pkj8xy" />
      </Deferred>

      {/* APLICACIÓN COMERCIAL */}
      <Deferred minHeight="1000px" data-id="element-16" data-mp="13dwtnvpjgvuc">
        <SellSection data-id="element-17" data-mp="13ey4q06k1ic2" />
      </Deferred>

      {/* PRECIO — primera revelación */}
      <Deferred minHeight="820px" background="bg-[#E9F0D5]" data-id="element-18" data-mp="1r5kafkt36qiw">
        <OfferSection data-id="element-19" data-mp="1w33skvswnng4" />
      </Deferred>

      {/* OBJECIONES */}
      <Deferred minHeight="820px" background="bg-ivory" data-id="element-20" data-mp="1w19dhy4bepjy">
        <FaqSection data-id="element-21" data-mp="1i2j7fszipfjg" />
      </Deferred>

      {/* COMPRA */}
      <Deferred minHeight="820px" data-id="element-22" data-mp="1m560fx7xd6i8">
        <FinalCta data-id="element-23" data-mp="1m44rbyagyu35" />
      </Deferred>

      <Deferred minHeight="340px" background="bg-bone" data-id="element-24" data-mp="1m792jfmcqq3b">
        <Footer data-id="element-25" data-mp="6o5v9le4moj9" />
      </Deferred>

      <Suspense fallback={null} data-id="element-26" data-mp="6n4bmsj1otpx">
        <StickyBuyBar data-id="element-27" data-mp="aq0umkchyrue" />
      </Suspense>
    </main>;
}